/*
 * @Author: edvardchen
 * @Date: 2017-11-08 17:37:29
 * @Last Modified by: edvardchen
 * @Last Modified time: 2018-03-20 23:03:34
 */

// @flow
import { type Action, type AllComments, type Reducer, type Comment } from '../types';

import { MORE_FETCH_FAIL, MORE_FETCH_START, MORE_FETCH_SUCCESS } from './actions';

const fetchReducer = (state: AllComments, hotComments: Comment[], { type, payload }: Action) => {
  switch (type) {
    case MORE_FETCH_START:
      return {
        ...state,
        fetchStatus: 'fetching',
      };
    case MORE_FETCH_FAIL:
      return {
        ...state,
        fetchStatus: 'error',
      };
    case MORE_FETCH_SUCCESS: {
      if (!payload || typeof payload !== 'object') {
        return state;
      }
      const { items, isEnd, ...rest } = payload;
      const result = { ...state, ...rest, fetchStatus: 'success' };

      if (Array.isArray(items)) {
        const ids = {};
        const extractId = ({ id }) => {
          ids[id] = 1;
        };
        result.items.map(extractId);
        hotComments.map(extractId);
        const realNewItems = items.filter(({ id }) => {
          if (ids[id]) {
            return false;
          }
          ids[id] = 1;
          return true;
        });

        result.items = result.items.concat(realNewItems);
        result.isEnd = isEnd;
      }
      return result;
    }
    default:
      return state;
  }
};

const reducer: Reducer = (state, action) => ({
  ...state,
  allComments: fetchReducer(state.allComments, state.hotComments, action),
});

export default reducer;
